import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQueryWithReauth';

export interface Channel { id: string; name: string; }

export const slackApi = createApi({
  reducerPath: 'slackApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Channel'],
  endpoints: (builder) => ({
    getChannels: builder.query<Channel[], void>({
      query: () => ({ url: '/slack/channels' }),
      providesTags: ['Channel'],
    }),
    createChannel: builder.mutation<Channel, Partial<Channel>>({
      query: (body) => ({ url: '/slack/channels', method: 'POST', body }),
      invalidatesTags: ['Channel'],
    }),
    deleteChannel: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({ url: `/slack/channels/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Channel'],
    }),
  }),
});

export const { useGetChannelsQuery, useCreateChannelMutation, useDeleteChannelMutation } = slackApi;
